import { Dialog } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { useDevice } from "../../../providers/DeviceProvider";


const useStyles = makeStyles()(
  (theme) => ({
    fullScreen: {
      "& .MuiDialog-paperFullScreen": {
        borderRadius: 0,
      }
    },
    isMobilePortraitView: {
      "& .MuiDialogContent-root": {
        padding: theme.spacing(1.5),
      },
      "& h2.MuiTypography-root.MuiDialogTitle-root": {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingTop: theme.spacing(1.5),
        paddingBottom: theme.spacing(1.5)
      },
      "& .MuiDialogActions-root": {
        padding: theme.spacing(1.5),
        paddingBottom: theme.spacing(0),
        flexDirection: "column-reverse",
        "& > button": {
          width: "100%",
          margin: 0,
          marginBottom: theme.spacing(1),
          padding: theme.spacing(1),
          flex: 1,
        }
      }
    }
  })
);

export default function ResponsiveDialog(props) {
  const { open, fullWidth, maxWidth, onClose, fullScreen, onKeyUp, className } = props;
  const { classes } = useStyles();
  const { isMobilePortraitView } = useDevice();
  const full = isMobilePortraitView || fullScreen;

  return (
    <Dialog
      onKeyUp={onKeyUp}
      open={open}
      onClose={onClose}
      fullWidth={fullWidth}
      fullScreen={full}
      maxWidth={maxWidth}
      className={`${full ? classes.fullScreen : ""} ${isMobilePortraitView ? classes.isMobilePortraitView : ""} ${className || ""}`}
    >
      {props.children}
    </Dialog>
  );
}


